import { getParsedToken } from "./getParsedToken";
import { determineLoggedInUserRole } from "./keycloak";
import { Role } from "@/../generated/apollo";

export type TokenUserInfo = {
  id: string;
  email: string;
  role: Role | null;
};

export function getTokenUserInfo(): TokenUserInfo {
  const token = getParsedToken();
  const role = determineLoggedInUserRole();
  return {
    id: token.sub,
    email: token.email,
    role,
  };
}
